import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button, Card, Flex, List, Space, Switch, Typography } from "antd"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"

const { Text } = Typography

const FilterDropdown = ({ onApply, onClearAll, onClose, initialFilters = {} }) => {
  const { t } = useTranslation()
  const [filters, setFilters] = useState({
    allCategories: initialFilters.allCategories || false,
    boatsAndVehicles: initialFilters.boatsAndVehicles || false,
    fishingGear: initialFilters.fishingGear || false,
    safetyAndLifeSupport: initialFilters.safetyAndLifeSupport || false,
    other: initialFilters.other || false
  })

  const handleToggle = (filterKey, checked) => {
    setFilters((prev) => ({
      ...prev,
      [filterKey]: checked
    }))
  }

  const handleClearAll = () => {
    const clearedFilters = Object.keys(filters).reduce((acc, key) => {
      acc[key] = false
      return acc
    }, {})
    setFilters(clearedFilters)
    onClearAll?.(clearedFilters)
    onClose?.()
  }

  const handleApply = () => {
    onApply?.(filters)
    onClose?.()
  }

  const categories = [
    { key: "allCategories", label: t("experiences.filters.all_categories") },
    { key: "boatsAndVehicles", label: t("experiences.filters.boats_and_vehicles") },
    { key: "fishingGear", label: t("experiences.filters.fishing_gear") },
    { key: "safetyAndLifeSupport", label: t("experiences.filters.safety_and_life_support") },
    { key: "other", label: t("experiences.filters.other") }
  ]

  return (
    <Card size="small" bordered={false} className={styles.container}>
      <List
        dataSource={categories}
        className={styles.content}
        renderItem={(category) => (
          <List.Item
            key={category.key}
            className={`${styles.categoryItem} ${filters[category.key] ? styles.active : ""}`}
            onClick={() => handleToggle(category.key, !filters[category.key])}
          >
            <Space size={12} className={styles.categoryRow}>
              <Switch
                checked={filters[category.key]}
                onChange={(checked) => handleToggle(category.key, checked)}
                onClick={(_, event) => event?.stopPropagation?.()}
              />
              <Text className={styles.categoryLabel}>{category.label}</Text>
            </Space>
          </List.Item>
        )}
      />
      <Flex align="center" justify="space-between" gap={10} className={`${styles.filterDropdownButtons} py-s px-xs`}>
        <Button color="primary" variant="outlined" size="large" shape="round" className="flex-1" onClick={handleClearAll}>
          {t("experiences.clear_all")}
        </Button>
        <Button size="large" type="primary" shape="round" className="flex-1" onClick={handleApply}>
          {t("experiences.apply")}
        </Button>
      </Flex>
    </Card>
  )
}

FilterDropdown.propTypes = {
  onApply: PropTypes.func,
  onClearAll: PropTypes.func,
  onClose: PropTypes.func,
  initialFilters: PropTypes.shape({
    allCategories: PropTypes.bool,
    boatsAndVehicles: PropTypes.bool,
    fishingGear: PropTypes.bool,
    safetyAndLifeSupport: PropTypes.bool,
    other: PropTypes.bool
  })
}

export default FilterDropdown
